<template>
    <div>
        <list class="m-0 p-0" v-model="categories" :columns="columns" :pagination="pagination"
              :actionsMinWidth="150"
              :sort-change="sortChange"
              :actions="actions"
              :edit="(props) => edit(props.row)"
              :enter="(props) => $router.push({ name: 'QuestionList', params: { id: props.row.$id } })"
              :remove="(props) => confirmAndDelete(props.row)"
              :title="$t('Question Topics')"
        />
        <modal v-if="category" v-model="showDialog" :title="category._id ? $t('Edit Question Topic') : $t('Create Question Topic')" :submit="save" :cancel="cancel" submit-text="Save">
            <template slot="body">
                <language-picker v-model="category.title">
                        <template slot="body" slot-scope="props">
                            <fg-input :name="`title${props.index}`"
                                      :label="$t('Title')"
                                      autocomplete="off"
                                      required
                                      :error="getError(`title${props.index}`)"
                                      v-model="category.title[props.index].text"
                                      v-validate="validations.title[props.index]"
                                      :placeholder="$t('Title')">
                            </fg-input>
                        </template>
                </language-picker>
            </template>
        </modal>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import BaseList from '../../Views/BaseList'
  import Modal from '../../Components/BasicModal'
  import List from '../../Components/BasicList'
  import LanguagePicker from '../../Components/BasicLanguagePicker'
  import QuestionCategoryModel from 'src/store/models/QuestionCategory'

  export default {
    name: 'QuestionCategoryList',
    components: { List, Modal, LanguagePicker },
    extends: BaseList,
    data () {
      return {
        showDialog: false,
        category: null,
        sf: 'createdAt',
        so: 'desc',
        columns: [
          { name: 'title', text: 'Title', formatter: this.languageFormatter, sortable: true, align: 'left' },
          { name: 'createdAt', text: 'Created at', formatter: this.dateFormatter, sortable: true, align: 'left' }
        ],
        actions: [
          { label: 'Add Question Topic', click: this.add }
        ],
        validations: {
          title: {
            0: {
              required: true,
              min: 5
            }
          }
        }
      }
    },
    methods: {
      ...mapActions('pagination/questionCategory', ['paginate']),
      filter: function () {
        return this.category.title.map(o => ({language: o.language, title: o.text}))
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      fetchCurrentPage: async function () {
        try {
          const newPage = parseInt(this.$route.query.page, 10) || 1
          await QuestionCategoryModel.deleteAll()
          const result = await QuestionCategoryModel.api().get('/questionCategory', {
            dataKey: 'items',
            params: { search: this.query, sf: this.sf, so: this.so, l: this.pagination.perPage, lo: newPage - 1 }
          })
          if (result.response && result.response.data && result.response.data.total) {
            this.paginate({
              perPage: this.pagination.perPage,
              currentPage: newPage,
              total: result.response.data.total
            })
          }
        } catch (e) { console.log('e', e)}
      },
      sortChange: function ({ column, prop, order }) {
        this.sf = prop || 'createdAt'
        this.so = (order || 'descending') === 'ascending' ? 'asc' : 'desc'
        this.fetchCurrentPage()
      },
      changePage (val) {
        const page = val > 1 ? val : undefined
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, page } })
      },
      confirmAndDelete: function (category) {
        this.$dialog.confirm(this.$t(`Confirm`), this.$t('Are you sure to delete {category}?', { category: this.$options.filters.languageString(category.title) }), this.$t('Delete'))
          .then(async () => {
            await QuestionCategoryModel.api().delete(`/questionCategory/${category._id}`)
            await this.fetchCurrentPage()
          })
      },
      getError (fieldName) {
        return this.$t(this.errors.first(fieldName))
      },
      add: async function () {
        let questionnaireLimit = this.$auth.user.customer.settings.contract.questionaireLimit

        if (questionnaireLimit > this.categories.length) {
          this.category = new QuestionCategoryModel(QuestionCategoryModel.defaults(this.$auth.user.customer.settings.contract.enabledLanguages))
          this.showDialog = true
        } else {
          this.$dialog.info(this.$t('Information'), this.$t('Your package does not allow any additional question topics.<br>For more informations please contact your administrator.', { limit: questionnaireLimit }), 'OK')
        }
      },
      edit: async function (category) {
        this.category = category
        this.showDialog = true
      },
      save: async function () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        const { title } = this.category
        const data = { title }
        try {
          if (this.category._id) {
            await QuestionCategoryModel.api().put(`/questionCategory/${this.category._id}`, data, { save: false })
            this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })

          } else {

            const result = await QuestionCategoryModel.api().post(`/questionCategory`, data, { save: false })

            if (result.response.data._id) {
              this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })
            }
          }
          this.showDialog = false
          await this.fetchCurrentPage()
        } catch (e) {
          this.$notify({ message: e.message, type: 'danger' })
        }
      },
      cancel: function () {
        this.showDialog = false
      }
    },
    computed: {
      categories: () => QuestionCategoryModel.all(),
      ...mapState('pagination', {
        pagination: (pagination) => pagination.questionCategory
      })
    },
    async mounted () {
      await this.fetchCurrentPage()
    },
    watch: {
      '$route.query.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchCurrentPage()
        }
      }
    }
  }
</script>
